import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface WorkflowErrorState {
  isLoading: boolean
  error: {
    statusCode?: number
    status?: string
    description?: string
  } | null
}

const initialState: WorkflowErrorState = {
  isLoading: false,
  error: null
}

const slice = createSlice({
  name: 'workflowError',
  initialState,
  reducers: {
    // Start workflow operation
    startWorkflow(state) {
      state.isLoading = true
      state.error = null
    },

    // Workflow completed successfully
    workflowSuccess(state) {
      state.isLoading = false
      state.error = null
    },

    // Workflow failed with error
    workflowError(state, action: PayloadAction<{ statusCode?: number; status?: string; description?: string }>) {
      state.isLoading = false
      state.error = {
        statusCode: action.payload.statusCode,
        status: action.payload.status,
        description: action.payload.description || 'An error occurred while processing your request.'
      }
    },

    // Clear workflow error
    clearWorkflowError(state) {
      state.error = null
    },

    // Reset workflow state
    resetWorkflow(state) {
      state.isLoading = false
      state.error = null
    }
  }
})

export const { startWorkflow, workflowSuccess, workflowError, clearWorkflowError, resetWorkflow } = slice.actions
export default slice.reducer
